export default {
  linkedIn: '/api/users/auth/linkedin',
  signUp: '/api/users/signup/',
  signIn: '/api/users/signin/',
  me: '/api/users/me/',
  logout: '/api/users/logout/',
  confirmEmail: '/api/users/confirm/',
  forgotPass: '/api/users/recover/',
  documents: '/api/documents/',
  getDocumentsEndpoint: id => `/api/documents/${id || ''}`,
  links: id => `/api/links/${id || ''}`,
  payment: '/api/users/payment/',
  plans: '/api/plans/',
  accounts: '/api/accounts',
  subscriptions: '/api/subscriptions',
  docAvailability: id => `/api/links/${id}/availability`,
  updateProfile: id => `/api/users/${id}`,
  updatePassword: id => `/api/users/${id}/password`,
  updateAvatar: id => `/api/users/${id}/avatar`,
  groups: '/api/groups/',
  uploadWatermark: id => `/api/accounts/${id}/watermark`,
  uploadBranding: id => `/api/accounts/${id}/branding`,
  updateCustomURL: id => `/api/accounts/${id}/branding/customURL`,
  updateBrandingColor: id => `/api/accounts/${id}/branding/color`,
  verifyEmail: id => `/api/links/${id}/verifyEmail`,
  findByToken: `/api/users/byToken`,
  library: '/api/users/library',
  users: () => `/api/users/`,
  shareLink: () => `/api/links/share`,
  requestConfirmation: () => `/api/users/reconfirm`,
  promos: '/api/promos/redeem',
  visitCount: () => `/api/visits/count`,
  recentLeads: () => `/api/documents/leads/recent`,
  recentDocumentVisits: () => `/api/documents/visits/recent`,
  totalStorage: () => '/api/documents/storage',
  folders: id => `/api/folders/${id || ''}`,
  documentsReport: () => `/api/reports/documents`,
  campaignsReport: () => `/api/reports/campaigns`,
  searchContent: () => `/api/search`,
  leads: () => `/api/leads`,
  teams: (id, userId) => `/api/teams/${id || ''}${userId ? '/members/' + userId : ''}`,
  stripeCheckoutSession: () => `/api/stripe/create-checkout-session`,
  stripeSessionStatus: () => `/api/stripe/session-status`,
  billingPortal: () => `/api/stripe/create-billing-session`,
};
